export const initMathJax = () => {
    window.MathJax = {
        tex: {
            inlineMath: [['$$', '$$'], ['\\(', '\\)']]
        },
    };
    (function () {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3.2.2/es5/tex-svg.js';
        script.async = true;
        document.head.appendChild(script);
    })();
}
// script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js';
